import React, { FC } from 'react';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { DocumentErrorActionFragment, DocumentErrorFragment } from 'graphql/__generated__/types';
import { UitkPrimaryButton, UitkSecondaryButton } from 'uitk-react-button';
import { UitkSpacing } from 'uitk-react-spacing';

interface DocumentErrorViewProps {
  errorResponse: DocumentErrorFragment;
}

const DocumentErrorView: FC<DocumentErrorViewProps> = ({ errorResponse }) => {
  const {
    messageText: { text },
    descriptionText: { text: descriptionText },
    buttons,
  } = errorResponse;

  const getPrimaryButton = (message: string, url: string) => (
    <UitkPrimaryButton tag="a" href={url} key={url}>
      {message}
    </UitkPrimaryButton>
  );

  const getSecondaryButton = (message: string, url: string) => (
    <UitkSecondaryButton tag="a" href={url} key={url}>
      {message}
    </UitkSecondaryButton>
  );

  const getButton = (button: DocumentErrorFragment['buttons'][0]) => {
    const actionUrl = (button.action as DocumentErrorActionFragment).resource.value;

    if (button.__typename === 'UIPrimaryButton') {
      return getPrimaryButton(button.primary, actionUrl);
    }

    return getSecondaryButton(button.primary, actionUrl);
  };

  return (
    <UitkLayoutFlex direction="column" alignItems="center" justifyContent="center" className="height-full" space="two">
      <UitkLayoutFlexItem>
        <UitkHeading tag="h2" size={4}>
          {text}
        </UitkHeading>
      </UitkLayoutFlexItem>
      <UitkLayoutFlexItem>
        <UitkText whiteSpace="pre-line" align="center">
          {descriptionText}
        </UitkText>
      </UitkLayoutFlexItem>
      <UitkSpacing margin="four">
        <UitkLayoutFlex direction="row" alignItems="center" justifyContent="center" space="four" key="key">
          {buttons.map((button) => getButton(button))}
        </UitkLayoutFlex>
      </UitkSpacing>
    </UitkLayoutFlex>
  );
};

export default DocumentErrorView;
